import { Component, OnInit } from '@angular/core';
import { User }              from '.././users/models/user';
import { AuthService }       from '.././providers/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {

  private isLoggedIn: boolean;
  private user: User;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.getUser().subscribe(user => {
      this.user = user;
    })
  }

  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};

  public toggled(open:boolean):void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  hideMenu() :void {
    document.getElementById('menuBtn').click();
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts